<template>
  <div
      class="home page-template-default page page-id-12105 wp-custom-logo header-horizontal site-layout-full elementor-default elementor-kit-12104 elementor-page elementor-page-12105">
    <div class="whole-layout">

      <main-header :tag-index="3"></main-header>

      <!-- 主体部分 -->
      <div class="f-mid-container">
        <div class="mid-bg-box">
          <div class="mid-bg-title">
            功能性成分
          </div>
          <div class="mid-bg-subtitle">
            用于美妆行业的活性成分
          </div>
        </div>
        <div class="mid-white-b-box">
          <div class="mid-white-box">
            <div class="mid-white-title">
              活性成分
            </div>
            <div class="mid-white-text">
              天妍可为化妆品和个人护理行业提供 200 多种创新活性成分，包括我们的明星产品 Matrixyl 系列。Matrixyl 系列的功效和安全性均已得到证实，能够满足消费者的新需求。<br><br>
              天妍的生物活性成分以研究为导向，致力于在护肤科学领域追求卓越，为护肤护发提供优秀的解决方案，解决各种问题，包括抗衰老、保湿、美白肌肤、均匀肤色、提高光泽度、抵御环境侵害、提升紧致度等。<br><br>
              在生物技术、分子合成、植物提取和植物细胞培养方面不断开发创新，产品不断推陈出新，以顺应消费趋势、匹配更可持续的生产技术，符合更高的质量和标准要求。
            </div>
            <div class="mid-white-img-box">
              <img class="mid-white-img" alt="小茉护肤" src="@/assets/images/field/react/f-r-main-pic-1.jpg">
            </div>
            <div class="mid-white-subtitle">
              30 年化妆品多肽合成经验
            </div>
            <div class="mid-white-text">
              天妍可为化妆品和个人护理行业提供 200 多种创新活性成分，包括我们的明星产品 Matrixyl 系列。Matrixyl 系列的功效和安全性均已得到证实，能够满足消费者的新需求。<br><br>
              天妍的生物活性成分以研究为导向，致力于在护肤科学领域追求卓越，为护肤护发提供优秀的解决方案，解决各种问题，包括抗衰老、保湿、美白肌肤、均匀肤色、提高光泽度、抵御环境侵害、提升紧致度等。<br><br>
              在生物技术、分子合成、植物提取和植物细胞培养方面不断开发创新，产品不断推陈出新，以顺应消费趋势、匹配更可持续的生产技术，符合更高的质量和标准要求。
            </div>
            <div class="mid-white-subtitle">
              超过 35 年的生物技术造诣
            </div>
            <div class="mid-white-text">
              天妍可为化妆品和个人护理行业提供 200 多种创新活性成分，包括我们的明星产品 Matrixyl 系列。Matrixyl 系列的功效和安全性均已得到证实，能够满足消费者的新需求。<br><br>
              天妍的生物活性成分以研究为导向，致力于在护肤科学领域追求卓越，为护肤护发提供优秀的解决方案，解决各种问题，包括抗衰老、保湿、美白肌肤、均匀肤色、提高光泽度、抵御环境侵害、提升紧致度等。<br><br>
              在生物技术、分子合成、植物提取和植物细胞培养方面不断开发创新，产品不断推陈出新，以顺应消费趋势、匹配更可持续的生产技术，符合更高的质量和标准要求。
            </div>
          </div>
          <div class="mid-aside-box">
            <div class="mid-aside-item mid-aside-item-1">
              <div class="mid-aside-title">
                MATRIXYL™ 系列 - 产品展示
              </div>
              <div class="mid-aside-main-box">
                <div class="mid-aside-main-img-box">
                  <img class="mid-aside-main-img" alt="小茉护肤" src="@/assets/images/field/react/f-r-main-pic-2.jpg">
                </div>
                <div class="mid-aside-main-text-box">
                  <div class="mid-aside-main-text">
                    4.1MB
                  </div>
                  <div class="mid-aside-main-text" style="margin-top: 26px">
                    登录下载
                  </div>
                  <div class="mid-aside-main-btn">
                    下载
                  </div>
                </div>
              </div>
            </div>
            <div class="mid-aside-item mid-aside-item-2">
              <div class="mid-aside-title">
                活性成分 - 产品目录
              </div>
              <div class="mid-aside-main-box">
                <div class="mid-aside-main-img-box">
                  <img class="mid-aside-main-img" alt="小茉护肤" src="@/assets/images/field/react/f-r-main-pic-3.jpg">
                </div>
                <div class="mid-aside-main-text-box">
                  <div class="mid-aside-main-text">
                    2.8MB
                  </div>
                  <div class="mid-aside-main-text" style="margin-top: 26px">
                    登录下载
                  </div>
                  <div class="mid-aside-main-btn">
                    下载
                  </div>
                </div>
              </div>
            </div>
            <div class="mid-aside-item mid-aside-item-3">
              <div class="mid-aside-title-img-box">
                <img class="mid-aside-title-img" alt="小茉护肤" src="@/assets/images/field/react/f-r-main-pic-4.jpg">
              </div>
              <div class="mid-aside-title" style="text-align: center; margin-top: 20px">
                生物技术
              </div>
              <div class="mid-aside-main-box">
                <div class="mid-aside-main-text-box">
                  <div class="mid-aside-main-text" style="text-align: center">
                    受大自然启发，生物技术利用生物体细胞和生物分子工艺，为创造创新、天然且适合纯素食者的成分提供了无限的潜力。
                  </div>
                  <div class="mid-aside-main-btn" style="margin-left: auto; margin-right: auto">
                    了解更多
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tip-content-box">
          <div class="content-img-box">
            <img src="@/assets/images/field/react/f-r-mid.jpg" alt="天妍" class="content-img">
          </div>
          <div class="content-text-box">
            <div class="content-text-title">
              了解我们的植物提取活性成分
            </div>
            <div class="content-text-subtitle">
              “查找产品”中展示了经证实具有功效的前沿产品。
            </div>
            <div class="content-text-btn">
              探索
            </div>
          </div>
        </div>
        <div class="con-content-box">
          <div class="content-title">
            天妍的主要活性成分
          </div>
          <div class="content-items">
            <div class="content-item">
              <div class="content-item-img-box">
                <img src="@/assets/images/field/f-1.jpg" alt="小茉护肤" class="content-item-img content-item-img-1">
              </div>
              <div class="content-item-text-box">
                <div class="content-item-title">
                  MATRIXYL® 3000
                </div>
                <div class="content-item-text">
                  Matrikines 抗皱纹复合物通过调节衰老标记，帮助逆转实际年龄衰老，通过重构乳突真皮层的脆弱网络，减少皮肤光损害。
                </div>
                <div class="content-item-btn">
                  申请样品
                </div>
              </div>
            </div>
            <div class="content-item">
              <div class="content-item-img-box">
                <img src="@/assets/images/field/f-2.jpg" alt="小茉护肤" class="content-item-img content-item-img-2">
              </div>
              <div class="content-item-text-box">
                <div class="content-item-title">
                  BB-BIONT™
                </div>
                <div class="content-item-text">
                  BB-BIONT™是一种可以平滑痘痕的仿生肽。
                </div>
                <div class="content-item-btn">
                  申请样品
                </div>
              </div>
            </div>
            <div class="content-item">
              <div class="content-item-img-box">
                <img src="@/assets/images/field/f-3.jpg" alt="小茉护肤" class="content-item-img content-item-img-3">
              </div>
              <div class="content-item-text-box">
                <div class="content-item-title">
                  APISCALP®
                </div>
                <div class="content-item-text">
                  Apiscalp® 设计用于让油性头皮和干性头皮更好看，更舒爽。Apiscalp™ 止屑、止痒，抗干燥，抗皮脂分泌过多。Apiscalp® 取自天然，为所有类型的头皮提供一个多合一方案
                </div>
                <div class="content-item-btn">
                  申请样品
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-content-box">
          <div class="content-title">
            浏览我们的专业领域
          </div>
          <div class="content-items">
            <div class="content-item">
              <div class="content-item-img-box">
                <img src="@/assets/images/field/f-1.jpg" alt="小茉护肤" class="content-item-img content-item-img-1">
              </div>
              <div class="content-item-text-box">
                <div class="content-item-title">
                  活性成分
                </div>
                <div class="content-item-text">
                  小茉护肤可为化妆品和个人护理行业提供 200 多种创新活性成分，包括我们的明星产品 Matrixyl 系列。Matrixyl 系列的功效和安全性均已得到证实，能够满足消费者的新需求。
                </div>
                <div class="content-item-btn" @click="pathTo('/field/react')">
                  了解更多
                </div>
              </div>
            </div>
            <div class="content-item">
              <div class="content-item-img-box">
                <img src="@/assets/images/field/f-2.jpg" alt="小茉护肤" class="content-item-img content-item-img-2">
              </div>
              <div class="content-item-text-box">
                <div class="content-item-title">
                  生物技术
                </div>
                <div class="content-item-text">
                  受大自然启发，生物技术利用生物体细胞和生物分子工艺，为创造创新、天然且适合纯素食者的成分提供了无限的潜力。
                </div>
                <div class="content-item-btn" @click="pathTo('/field/bio')">
                  了解更多
                </div>
              </div>
            </div>
            <div class="content-item">
              <div class="content-item-img-box">
                <img src="@/assets/images/field/f-3.jpg" alt="小茉护肤" class="content-item-img content-item-img-3">
              </div>
              <div class="content-item-text-box">
                <div class="content-item-title">
                  植物提取物
                </div>
                <div class="content-item-text">
                  天妍作为拥有40多年经验的植物提取物的专家，能开拓创新和专有的提取技术，这些技术更加可持续性，并保存了我们植物中更多活性和有用的分子。
                </div>
                <div class="content-item-btn" @click="pathTo('/field/tree')">
                  了解更多
                </div>
              </div>
            </div>
            <div class="content-item">
              <div class="content-item-img-box">
                <img src="@/assets/images/field/f-4.jpg" alt="小茉护肤" class="content-item-img content-item-img-4">
              </div>
              <div class="content-item-text-box">
                <div class="content-item-title">
                  包裹技术
                </div>
                <div class="content-item-text">
                  我们为化妆品成分和香精产品提供各种粒度和功效的包裹技术。
                </div>
                <div class="content-item-btn" @click="pathTo('/field/pack')">
                  了解更多
                </div>
              </div>
            </div>
            <div class="content-item">
              <div class="content-item-img-box">
                <img src="@/assets/images/field/f-5.jpg" alt="小茉护肤" class="content-item-img content-item-img-5">
              </div>
              <div class="content-item-text-box">
                <div class="content-item-title">
                  香精
                </div>
                <div class="content-item-text">
                  我们的香精公司 Parfex 和 爱伯馨提供各种紧跟潮流、个性化且可持续的香精产品，能够满足美妆业不断发展的需求。
                </div>
                <div class="content-item-btn" @click="pathTo('/field/flavor')">
                  了解更多
                </div>
              </div>
            </div>
            <div class="content-item">
              <div class="content-item-img-box">
                <img src="@/assets/images/field/f-6.jpg" alt="小茉护肤" class="content-item-img content-item-img-6">
              </div>
              <div class="content-item-text-box">
                <div class="content-item-title">
                  功能性成分
                </div>
                <div class="content-item-text">
                  天妍生产创新、高效的功能性成分，致力于满足美妆行业的消费者需求。我们制定企业宗旨，拥有专业技术和研发设施，是功能性成分领域的潮流引领者。
                </div>
                <div class="content-item-btn" @click="pathTo('/field/comp')">
                  了解更多
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <main-footer></main-footer>

    </div>
  </div>
</template>

<script>
export default {
  name: 'AreaCompView',
  data() {
    return {
      scrolltop: 0,

      // 点击显示弹出框
      isCodePopShow: false,
      // 点击弹出下拉框
      isDropShow: false
    }
  },
  mounted() {
    // 在组件挂载后添加监听器
    window.addEventListener('wheel', this.handleWheel);
  },
  beforeDestroy() {
    // 组件销毁前移除监听器，避免内存泄漏
    window.removeEventListener('wheel', this.handleWheel);
  },
  methods: {
    handleWheel(event) {
      // 阻止默认行为（可选，根据需要）
      // event.preventDefault();
      // 获取滚动到顶部的距离
      this.scrolltop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    },
    pathTo(url) {
      this.$router.push({
        path: url
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/static/css/style.min.css";
@import "@/assets/static/css/elementor-icons.min.css";
@import "@/assets/static/css/custom-frontend.min.css";
@import "@/assets/static/css/post-12104.css";
@import "@/assets/static/css/global.css";
@import "@/assets/static/css/post-12105.css";
@import "@/assets/static/css/lightgallery.min.css";
@import "@/assets/static/css/font-awesome.min.css";
@import "@/assets/static/css/icomoon.css";
@import "@/assets/static/css/style.css";
@import "@/assets/static/css/user.css";
@import "@/assets/static/css/all.min.css";
@import "@/assets/static/css/v4-shims.min.css";
@import "@/assets/static/css/css-Raleway.css";
@import "@/assets/static/css/post-20.css";
@import "@/assets/static/css/css-SourceSansPro.css";
@import "@/assets/static/css/solid.min.css";
@import "@/assets/static/css/regular.min.css";

a {
  cursor: pointer;
}

.submenu-show {
  display: block;
}

.pic-box {
  width: 200px;

  .pic-img {
    width: 100%;
  }
}

.map-img {

}

.sub-menu-img {
  width: 140px;
}

/*! This file is auto-generated */
.wp-block-button__link {
  color: #fff;
  background-color: #32373c;
  border-radius: 9999px;
  box-shadow: none;
  text-decoration: none;
  padding: calc(.667em + 2px) calc(1.333em + 2px);
  font-size: 1.125em
}

.wp-block-file__button {
  background: #32373c;
  color: #fff;
  text-decoration: none
}

body {
  --wp--preset--color--black: #000000;
  --wp--preset--color--cyan-bluish-gray: #abb8c3;
  --wp--preset--color--white: #ffffff;
  --wp--preset--color--pale-pink: #f78da7;
  --wp--preset--color--vivid-red: #cf2e2e;
  --wp--preset--color--luminous-vivid-orange: #ff6900;
  --wp--preset--color--luminous-vivid-amber: #fcb900;
  --wp--preset--color--light-green-cyan: #7bdcb5;
  --wp--preset--color--vivid-green-cyan: #00d084;
  --wp--preset--color--pale-cyan-blue: #8ed1fc;
  --wp--preset--color--vivid-cyan-blue: #0693e3;
  --wp--preset--color--vivid-purple: #9b51e0;
  --wp--preset--gradient--vivid-cyan-blue-to-vivid-purple: linear-gradient(135deg, rgba(6, 147, 227, 1) 0%, rgb(155, 81, 224) 100%);
  --wp--preset--gradient--light-green-cyan-to-vivid-green-cyan: linear-gradient(135deg, rgb(122, 220, 180) 0%, rgb(0, 208, 130) 100%);
  --wp--preset--gradient--luminous-vivid-amber-to-luminous-vivid-orange: linear-gradient(135deg, rgba(252, 185, 0, 1) 0%, rgba(255, 105, 0, 1) 100%);
  --wp--preset--gradient--luminous-vivid-orange-to-vivid-red: linear-gradient(135deg, rgba(255, 105, 0, 1) 0%, rgb(207, 46, 46) 100%);
  --wp--preset--gradient--very-light-gray-to-cyan-bluish-gray: linear-gradient(135deg, rgb(238, 238, 238) 0%, rgb(169, 184, 195) 100%);
  --wp--preset--gradient--cool-to-warm-spectrum: linear-gradient(135deg, rgb(74, 234, 220) 0%, rgb(151, 120, 209) 20%, rgb(207, 42, 186) 40%, rgb(238, 44, 130) 60%, rgb(251, 105, 98) 80%, rgb(254, 248, 76) 100%);
  --wp--preset--gradient--blush-light-purple: linear-gradient(135deg, rgb(255, 206, 236) 0%, rgb(152, 150, 240) 100%);
  --wp--preset--gradient--blush-bordeaux: linear-gradient(135deg, rgb(254, 205, 165) 0%, rgb(254, 45, 45) 50%, rgb(107, 0, 62) 100%);
  --wp--preset--gradient--luminous-dusk: linear-gradient(135deg, rgb(255, 203, 112) 0%, rgb(199, 81, 192) 50%, rgb(65, 88, 208) 100%);
  --wp--preset--gradient--pale-ocean: linear-gradient(135deg, rgb(255, 245, 203) 0%, rgb(182, 227, 212) 50%, rgb(51, 167, 181) 100%);
  --wp--preset--gradient--electric-grass: linear-gradient(135deg, rgb(202, 248, 128) 0%, rgb(113, 206, 126) 100%);
  --wp--preset--gradient--midnight: linear-gradient(135deg, rgb(2, 3, 129) 0%, rgb(40, 116, 252) 100%);
  --wp--preset--font-size--small: 13px;
  --wp--preset--font-size--medium: 20px;
  --wp--preset--font-size--large: 36px;
  --wp--preset--font-size--x-large: 42px;
  --wp--preset--spacing--20: 0.44rem;
  --wp--preset--spacing--30: 0.67rem;
  --wp--preset--spacing--40: 1rem;
  --wp--preset--spacing--50: 1.5rem;
  --wp--preset--spacing--60: 2.25rem;
  --wp--preset--spacing--70: 3.38rem;
  --wp--preset--spacing--80: 5.06rem;
  --wp--preset--shadow--natural: 6px 6px 9px rgba(0, 0, 0, 0.2);
  --wp--preset--shadow--deep: 12px 12px 50px rgba(0, 0, 0, 0.4);
  --wp--preset--shadow--sharp: 6px 6px 0px rgba(0, 0, 0, 0.2);
  --wp--preset--shadow--outlined: 6px 6px 0px -3px rgba(255, 255, 255, 1), 6px 6px rgba(0, 0, 0, 1);
  --wp--preset--shadow--crisp: 6px 6px 0px rgba(0, 0, 0, 1);
}

:where(.is-layout-flex) {
  gap: 0.5em;
}

:where(.is-layout-grid) {
  gap: 0.5em;
}

body .is-layout-flex {
  display: flex;
}

body .is-layout-flex {
  flex-wrap: wrap;
  align-items: center;
}

body .is-layout-flex > * {
  margin: 0;
}

body .is-layout-grid {
  display: grid;
}

body .is-layout-grid > * {
  margin: 0;
}

:where(.wp-block-columns.is-layout-flex) {
  gap: 2em;
}

:where(.wp-block-columns.is-layout-grid) {
  gap: 2em;
}

:where(.wp-block-post-template.is-layout-flex) {
  gap: 1.25em;
}

:where(.wp-block-post-template.is-layout-grid) {
  gap: 1.25em;
}

.has-black-color {
  color: var(--wp--preset--color--black) !important;
}

.has-cyan-bluish-gray-color {
  color: var(--wp--preset--color--cyan-bluish-gray) !important;
}

.has-white-color {
  color: var(--wp--preset--color--white) !important;
}

.has-pale-pink-color {
  color: var(--wp--preset--color--pale-pink) !important;
}

.has-vivid-red-color {
  color: var(--wp--preset--color--vivid-red) !important;
}

.has-luminous-vivid-orange-color {
  color: var(--wp--preset--color--luminous-vivid-orange) !important;
}

.has-luminous-vivid-amber-color {
  color: var(--wp--preset--color--luminous-vivid-amber) !important;
}

.has-light-green-cyan-color {
  color: var(--wp--preset--color--light-green-cyan) !important;
}

.has-vivid-green-cyan-color {
  color: var(--wp--preset--color--vivid-green-cyan) !important;
}

.has-pale-cyan-blue-color {
  color: var(--wp--preset--color--pale-cyan-blue) !important;
}

.has-vivid-cyan-blue-color {
  color: var(--wp--preset--color--vivid-cyan-blue) !important;
}

.has-vivid-purple-color {
  color: var(--wp--preset--color--vivid-purple) !important;
}

.has-black-background-color {
  background-color: var(--wp--preset--color--black) !important;
}

.has-cyan-bluish-gray-background-color {
  background-color: var(--wp--preset--color--cyan-bluish-gray) !important;
}

.has-white-background-color {
  background-color: var(--wp--preset--color--white) !important;
}

.has-pale-pink-background-color {
  background-color: var(--wp--preset--color--pale-pink) !important;
}

.has-vivid-red-background-color {
  background-color: var(--wp--preset--color--vivid-red) !important;
}

.has-luminous-vivid-orange-background-color {
  background-color: var(--wp--preset--color--luminous-vivid-orange) !important;
}

.has-luminous-vivid-amber-background-color {
  background-color: var(--wp--preset--color--luminous-vivid-amber) !important;
}

.has-light-green-cyan-background-color {
  background-color: var(--wp--preset--color--light-green-cyan) !important;
}

.has-vivid-green-cyan-background-color {
  background-color: var(--wp--preset--color--vivid-green-cyan) !important;
}

.has-pale-cyan-blue-background-color {
  background-color: var(--wp--preset--color--pale-cyan-blue) !important;
}

.has-vivid-cyan-blue-background-color {
  background-color: var(--wp--preset--color--vivid-cyan-blue) !important;
}

.has-vivid-purple-background-color {
  background-color: var(--wp--preset--color--vivid-purple) !important;
}

.has-black-border-color {
  border-color: var(--wp--preset--color--black) !important;
}

.has-cyan-bluish-gray-border-color {
  border-color: var(--wp--preset--color--cyan-bluish-gray) !important;
}

.has-white-border-color {
  border-color: var(--wp--preset--color--white) !important;
}

.has-pale-pink-border-color {
  border-color: var(--wp--preset--color--pale-pink) !important;
}

.has-vivid-red-border-color {
  border-color: var(--wp--preset--color--vivid-red) !important;
}

.has-luminous-vivid-orange-border-color {
  border-color: var(--wp--preset--color--luminous-vivid-orange) !important;
}

.has-luminous-vivid-amber-border-color {
  border-color: var(--wp--preset--color--luminous-vivid-amber) !important;
}

.has-light-green-cyan-border-color {
  border-color: var(--wp--preset--color--light-green-cyan) !important;
}

.has-vivid-green-cyan-border-color {
  border-color: var(--wp--preset--color--vivid-green-cyan) !important;
}

.has-pale-cyan-blue-border-color {
  border-color: var(--wp--preset--color--pale-cyan-blue) !important;
}

.has-vivid-cyan-blue-border-color {
  border-color: var(--wp--preset--color--vivid-cyan-blue) !important;
}

.has-vivid-purple-border-color {
  border-color: var(--wp--preset--color--vivid-purple) !important;
}

.has-vivid-cyan-blue-to-vivid-purple-gradient-background {
  background: var(--wp--preset--gradient--vivid-cyan-blue-to-vivid-purple) !important;
}

.has-light-green-cyan-to-vivid-green-cyan-gradient-background {
  background: var(--wp--preset--gradient--light-green-cyan-to-vivid-green-cyan) !important;
}

.has-luminous-vivid-amber-to-luminous-vivid-orange-gradient-background {
  background: var(--wp--preset--gradient--luminous-vivid-amber-to-luminous-vivid-orange) !important;
}

.has-luminous-vivid-orange-to-vivid-red-gradient-background {
  background: var(--wp--preset--gradient--luminous-vivid-orange-to-vivid-red) !important;
}

.has-very-light-gray-to-cyan-bluish-gray-gradient-background {
  background: var(--wp--preset--gradient--very-light-gray-to-cyan-bluish-gray) !important;
}

.has-cool-to-warm-spectrum-gradient-background {
  background: var(--wp--preset--gradient--cool-to-warm-spectrum) !important;
}

.has-blush-light-purple-gradient-background {
  background: var(--wp--preset--gradient--blush-light-purple) !important;
}

.has-blush-bordeaux-gradient-background {
  background: var(--wp--preset--gradient--blush-bordeaux) !important;
}

.has-luminous-dusk-gradient-background {
  background: var(--wp--preset--gradient--luminous-dusk) !important;
}

.has-pale-ocean-gradient-background {
  background: var(--wp--preset--gradient--pale-ocean) !important;
}

.has-electric-grass-gradient-background {
  background: var(--wp--preset--gradient--electric-grass) !important;
}

.has-midnight-gradient-background {
  background: var(--wp--preset--gradient--midnight) !important;
}

.has-small-font-size {
  font-size: var(--wp--preset--font-size--small) !important;
}

.has-medium-font-size {
  font-size: var(--wp--preset--font-size--medium) !important;
}

.has-large-font-size {
  font-size: var(--wp--preset--font-size--large) !important;
}

.has-x-large-font-size {
  font-size: var(--wp--preset--font-size--x-large) !important;
}

.wp-block-navigation a:where(:not(.wp-element-button)) {
  color: inherit;
}

:where(.wp-block-post-template.is-layout-flex) {
  gap: 1.25em;
}

:where(.wp-block-post-template.is-layout-grid) {
  gap: 1.25em;
}

:where(.wp-block-columns.is-layout-flex) {
  gap: 2em;
}

:where(.wp-block-columns.is-layout-grid) {
  gap: 2em;
}

.wp-block-pullquote {
  font-size: 1.5em;
  line-height: 1.6;
}

/*脚部调整*/
#footer.centered {
  text-align: left;
}

#footer.centered, #footer.centered .widget h3.title, #footer.centered .widget .socials {
  text-align: left;
}

.foot-items, #footer .foot-widgets {
  padding-left: 200px;
}

@media screen and (max-width: 480px) {
  .widget {
    text-align: left;
  }
  .foot-items, #footer .foot-widgets {
    padding-left: 20px;
  }
}

.foot-img {
  display: flex;
  justify-content: center;
}

#footer .widget {
  font-size: 15px;
}

/*横杠*/
.elementor-divider-separator {
  border-radius: 8px;
}

/*分类归档名称调整*/
.posts-list .title-bar.outside .page-title {
  font-size: 0;
  padding-top: 30px;
}

.posts-list .title-bar.outside .page-title span {
  font-size: 48px;
}

/*菜单间距*/
.header-horizontal .top-menu > li > a {
  padding: 0 16px;
}

/*新闻动态*/
h2.post-title {
  font-size: 1em;
  line-height: 1.4em;
}

.item-image a::before {
  background-color: #0000008c;
}

.item-image a::after {
  font-size: 0;
}

@media only screen and (max-width: 768px) {
  .bricks-frame .formatter {
    padding-left: 0;
  }
}

.bricks-frame .formatter, .post_theme_options .formatter {
  padding-top: 20px;
}

/*规则菜单*/
.widget_nav_menu ul ul {
  margin: 0 0 0 16px;
}

.f-mid-container {
  width: 100%;
  position: relative;
  z-index: 2;

  .mid-bg-box {
    width: 100%;
    height: 600px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 20px;
    color: #fff;
    font-size: 48px;
    overflow: hidden;

    .mid-bg-title {
      font-weight: 400;
      color: #fff;
    }
    .mid-bg-subtitle {
      color: #fff;
      font-weight: 300;
    }
  }
  .mid-bg-box::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    background-image: url("@/assets/images/field/f-bg-6.jpg");
    background-size: 1920px auto;
    background-repeat: no-repeat;
    background-position: center -600px;
    filter: brightness(60%);
    height: 600px;
  }
  .mid-white-b-box {
    display: flex;
    width: 100%;
    align-items: flex-start;

    .mid-white-box {
      width: 75%;
      color: #000;
      padding: 40px 15%;
      //padding-left: 15%;
      //height: 250px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 20px;

      .mid-white-title {
        font-weight: 300;
        font-size: 48px;
      }
      .mid-white-subtitle {
        color: #3c2c32;
        word-break: break-word;
        line-height: 1.5;
        font-size: 30px;
        margin-top: 30px;
      }
      .mid-white-text {
        color: #3c2c32;
        word-break: break-word;
        line-height: 1.5;
      }
      .mid-white-img-box {
        width: 100%;
        height: 260px;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;

        .mid-white-img {
          width: 100%;
        }
      }
    }
    .mid-aside-box {
      width: 25%;
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      gap: 2px;

      .mid-aside-item {
        padding: 40px 40px;
        color: #fff;

        .mid-aside-title-img-box {
          height: 187px;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;

          .mid-aside-title-img {
            width: 400px;
          }
        }
        .mid-aside-title {
          font-size: 30px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.3);
          padding-bottom: 20px;
        }
        .mid-aside-main-box {
          margin-top: 20px;
          display: flex;
          height: 140px;
          gap: 30px;

          .mid-aside-main-img-box {
            height: 140px;
            width: 105px;
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;

            .mid-aside-main-img {
              width: 105px;
            }
          }
          .mid-aside-main-text-box {

            .mid-aside-main-text {

            }
            .mid-aside-main-btn {
              margin-top: 20px;
              border: 1px solid #fff;
              color: #fff;
              padding: 14px 30px;
              width: fit-content;
              cursor: pointer;
            }
          }
        }
      }
      .mid-aside-item-1 {
        background-color: #3c2c32;
      }
      .mid-aside-item-2 {
        background-color: #3a3054;
      }
      .mid-aside-item-3 {
        background-color: #7d6b7e;
      }
    }
  }
  /* 腰封 */
  .tip-content-box {
    width: 100%;
    height: 400px;
    display: flex;

    .content-img-box {
      width: 50%;
      height: 400px;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;

      .content-img {

      }
    }
    .content-text-box {
      width: 50%;
      background-color: #035940;
      color: #fff;
      padding-left: 120px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .content-text-title {
        font-size: 26px;
      }
      .content-text-subtitle {
        margin-top: 20px;
        font-size: 16px;
      }
      .content-text-btn {
        margin-top: 40px;
        border: 1px solid #fff;
        color: #fff;
        padding: 14px 40px;
        width: fit-content;
        cursor: pointer;
      }
    }
  }
  /* 活性成分 */
  .con-content-box {
    padding: 48px 64px;
    background-color: #e6f2e6;

    .content-title {
      font-weight: 400;
      color: #333;
      font-size: 40px;
      text-align: center;
    }
    .content-items {
      margin-top: 32px;
      display: flex;
      gap: 32px;
      flex-direction: row;
      flex-wrap: wrap;

      .content-item {
        background-color: #035940;
        //display: flex;
        flex-basis: calc(33% - 16px);
        min-width: calc(33% - 16px);
        flex-shrink: 0;

        .content-item-img-box {
          position: relative;
          overflow: hidden;
          aspect-ratio: auto;
          margin: 0;
          //width: 40%;
          //flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 300px;

          .content-item-img {
            position: absolute;
            //width: 450px;
            //inset: -3.10831% 0px 0px;
            //max-width: 100%;
            width: 600px;
          }
          .content-item-img-1 {
            width: 600px;
          }
          .content-item-img-2 {
            width: 600px;
          }
          .content-item-img-3 {
            width: 600px;
          }
          .content-item-img-4 {
            width: 520px;
          }
          .content-item-img-5 {
            width: 480px;
          }
          .content-item-img-6 {
            width: 520px;
          }
          .content-item-img-7 {
            width: 450px;
          }
        }
        .content-item-text-box {
          //flex-basis: 50%;
          text-align: left;
          flex: 1 1 auto;
          min-height: 1px;
          padding: 40px;
          display: flex;
          flex-direction: column;
          //width: 50%;

          .content-item-title {
            padding-bottom: 20px;
            border-bottom: 1px solid hsla(0, 0%, 100%, .1);
            border-bottom-color: rgba(60, 44, 50, .3);
            font-size: 26px;
            color: #fff;
          }
          .content-item-text {
            margin-top: 20px;
            color: #fff;
            line-height: 1.5;
            margin-bottom: 20px;
            height: 100px;
          }
          .content-item-btn {
            //background-color: #035940;
            border: 1px solid #fff;
            color: #fff;
            padding: 14px 40px;
            margin: auto auto;
            width: fit-content;
            cursor: pointer;
          }
        }
      }
    }
  }
  /* 底部博客 */
  .btn-content-box {
    padding: 48px 64px;
    background-color: #fff;

    .content-title {
      font-weight: 400;
      color: #333;
      font-size: 40px;
      text-align: center;
    }
    .content-items {
      margin-top: 32px;
      display: flex;
      gap: 32px;
      flex-direction: row;
      flex-wrap: wrap;

      .content-item {
        background-color: #f3e7d1;
        display: flex;
        flex-basis: calc(33% - 16px);
        min-width: calc(33% - 16px);
        flex-shrink: 0;

        .content-item-img-box {
          position: relative;
          overflow: hidden;
          aspect-ratio: auto;
          margin: 0;
          width: 40%;
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;

          .content-item-img {
            position: absolute;
            //width: 450px;
            //inset: -3.10831% 0px 0px;
            //max-width: 100%;
            width: 450px;
          }
          .content-item-img-1 {
            width: 440px;
          }
          .content-item-img-2 {
            width: 440px;
          }
          .content-item-img-3 {
            width: 690px;
          }
          .content-item-img-4 {
            width: 520px;
          }
          .content-item-img-5 {
            width: 480px;
          }
          .content-item-img-6 {
            width: 520px;
          }
          .content-item-img-7 {
            width: 450px;
          }
        }
        .content-item-text-box {
          //flex-basis: 50%;
          text-align: left;
          flex: 1 1 auto;
          min-height: 1px;
          padding: 40px;
          display: flex;
          flex-direction: column;
          width: 50%;

          .content-item-title {
            padding-bottom: 20px;
            border-bottom: 1px solid hsla(0, 0%, 100%, .1);
            border-bottom-color: rgba(60, 44, 50, .3);
            font-size: 26px;
            color: #000;
          }
          .content-item-text {
            margin-top: 20px;
            color: #3c2c32;
            line-height: 1.5;
            margin-bottom: 20px;
          }
          .content-item-btn {
            background-color: #035940;
            border-color: #035940;
            color: #fff;
            padding: 14px 40px;
            margin-top: auto;
            width: fit-content;
            cursor: pointer;
          }
        }
      }
    }
  }
}

</style>
